import React, {useEffect, useState} from 'react';
import { Link, Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import {Box, LinearProgress, withStyles} from "@material-ui/core";
import noimage from './img/noimage.png';
import * as numeral from 'numeral';
import * as constants from "constants";
import Typography from "@material-ui/core/Typography";
import {lighten} from "@material-ui/core/styles";
import Auth from "./store/AuthStore";


export class LazyImage extends React.Component {
    constructor(p){
      super(p);
      this._isMounted = false;
    }
    state = {
      // short for "module" but that's a keyword in js, so "mod"
      mod: null
    }
  
    componentDidMount() {
      this._isMounted = true;
      this.load(this.props)
    }
  
    componentWillUnmount(){
      this._isMounted = false;
    }
  
    componentWillReceiveProps(nextProps) {
      if (nextProps.load !== this.props.load) {
        this.load(nextProps)
      }
    }

    setImage = (src) => {
      let image = new Image;
      let div = document.createElement('div');
      div.classList = 'Item__image__placeholder';
      div.innerHTML = 'Loading';
      this.node.appendChild(div);
      image.src = src.default ? src.default : src;
      //image.setAttribute('loading','lazy');
      image.onError= ev => ev.target.src = noimage;
      image.onload = () => {
          if(this.node){
              this.node.innerHTML = '';
              this.node.appendChild(image);
          }
      }
    }
  
    load(props) {
      try {
        let that = this;
        if(typeof props.load  === 'string'){
            that.setImage(props.load);
            return
        } 
        
        props.load().then((src) => {
          that.setImage(src);
        })

      } catch (error) {
        console.error(error)
      }
    }
  
    render() {
      let {mod , ...rest} = this.props;
      return  <div className="Item__image" ref={node => this.node = node} />
    }
}

// Promise debouncer
export function debounce2(func, wait, immediate) {
	var timeout;
	return ((...args) => {
    var context = this;
    return new Promise(resolve => {

      var later = () => {
        timeout = null;
        if (!immediate) resolve( func.apply(context, args) );
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) resolve( func.apply(context, args) );

    });

  });
};

// Non-Promise debouncer
export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export function delegate(target, type, selector, handler, capture = false, once = false) {
    const dispatchEvent = (event) => {
        // console.time('delegate');
        let targetElement = event.target;
        while (targetElement && targetElement !== target ) {
        if ( typeof targetElement.matches == 'function' && targetElement.matches(selector)) {
          
            event.delegateTarget = event.delegateTarget || targetElement;
            handler.call(this, event);
            break;
        }
        targetElement = targetElement.parentNode;
        }
        // console.timeEnd('delegate');
    };

    target.addEventListener(type, dispatchEvent, !!capture);

    return () => target.removeEventListener(type, dispatchEvent, {capture: !!capture, once: !!once});

};


export function listener(target, type, handler, capture) {
  const dispatchEvent = (event) => {
      handler.call(this, event);
  };

  target.addEventListener(type, dispatchEvent, !!capture);

  return () => target.removeEventListener(type, dispatchEvent, !!capture);

};

export const clamp = (minOut, maxOut, v) => {
  return Math.max(Math.min(maxOut, Number(v)), minOut);
};


export const lerp = (minIn, maxIn, minOut, maxOut, opts = {}) => {
  const rangeIn = maxIn - minIn;
  const rangeOut = maxOut - minOut;
  
  return (v) => {
    v = opts.absolute ? Math.abs(v) : v;
    let p;
    if (opts.noClamp) p = (v - minIn) / rangeIn;
    else p = Math.max(Math.min((v - minIn) / rangeIn, 1), 0);
    return p * rangeOut + minOut;
  };
}

export const call = (fn, ...args) => {
  if (typeof fn === 'function') {
      return fn(...args);
  }
};


export function removeClass(element, className){
  if ( element.classList)
    element.classList.remove(className)
  else
    element.className = element.className
      .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
      .replace(/\s+/g, ' ')
      .replace(/^\s*|\s*$/g, '');
}

export function addClass(element, className){
  if ( element.classList)
    element.classList.add(className)
  else if ( !hasClass(element))
    element.className = element.className + ' ' + className
}

export function hasClass(element, className) {
  if ( element.classList)
    return !!className && element.classList.contains(className)
  else
    return ` ${element.className} `.indexOf(` ${className} `) !== -1
}


export const requestAnimationFramePromise = _ => new Promise(requestAnimationFrame);
export const transitionEndPromise = elem => new Promise(resolve => {
  elem.addEventListener('transitionend', resolve, {capture: false});
});


export const getUniqueKey = (key = '') => {
  return `${key?key+'-':''}${~~(Math.random()*1000)}_${~~(Math.random()*1000)}`
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export class Lazy extends React.Component {
  constructor(p){
    super(p);
    this._isMounted = false;
  }

  state = {
    // short for "module" but that's a keyword in js, so "mod"
    mod: null
  }

  componentWillMount() {
    this.load(this.props)
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount(){
    this._isMounted = false;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps)
    }
  }

  load(props) {
    let _self = this;
    props.load().then((mod) => {
      if(_self._isMounted)
      _self.setState({
        // handle both es imports and cjs
        mod: mod.default ? mod.default : mod
      })
    })
  }

  render() {
    let {load , ...rest} = this.props;
    return  React.createElement(
            'div', 
            null, 
            this.state.mod ? 
            React.createElement(this.state.mod, rest, null): 
            <p styles={{
              fontSize: '10px',
              marginTop: '10px',
              display: 'flex',
              alignItems: 'center',
              }}><span styles={{
              height: '21px',
              width: '20px',
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:after':{
                content: '\"\"',
                display: 'block',
                borderRadius: '50%',
                animation: 'repeate 1s cubic-bezier(0.4, 0, 1, 1) infinite ', 
                height: '5px',
                width: '5px',
                background: "#159eff"
              }
              }}/>
            </p>
            )
  }
}



export const addCss = (fileName, id = null) => {

  if(id && document.getElementById(id)){
    return
  }
  
  var head = document.head;
  var link = document.createElement("link");

  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = fileName;
  if(id){
    link.id = id;
  }

  head.appendChild(link);
}

export const addJS = (url, code, id = null, cb) => {

  if(id && document.getElementById(id)){
    return
  }

  var newScript = document.createElement("script");
  
  var head = document.head;

  newScript.type = "text/javascript";
  newScript.defer = true;

  if(url){
    newScript.src = url;
    if(typeof cb == 'function') newScript.onload = cb;
  }
  if(code){
    var inlineScript = document.createTextNode(code);
    newScript.appendChild(inlineScript); 
  }

  if(id){
    newScript.id = id;
  }

  head.appendChild(newScript);
}

export function mergeArraysOfObjects() {
    let hash = {};
    for (let l = 0; l < arguments.length; l++) {
        let arr = arguments[l];
        if (!arr.length) continue;
        for (let i = 0; i < arr.length; i++) {
            let el = arr[i];
            if (!('date' in el)) continue;
            let date = el.date;
            if (!hash[date]) hash[date] = {};
            for (let key in el) {
                if (el.hasOwnProperty(key))
                    hash[date][key] = el[key];
            }
        }
    }
    let result = [];
    for (let id in hash) {
        if (hash.hasOwnProperty(id)) result.push(hash[id]);
    }

    return result;
}

export const compileUrl = (base, path, params) => {
  try {
  if (!base) {
    throw new Error('Base url did not provided');
  }

  const url = `${base}${path}`;
 
    return url
      .split('/')
      .map(part => {
        
        const isParam = part.startsWith(':');
        const isOptional = part.endsWith('?');
        const paramName = part.replace(/^:|\?$/g, '').replace(':', '');
        var paramValue = params && params[paramName] || '';

        if (isParam && !isOptional && !paramValue) {
          throw new Error(`compileUrl function couldn't be accomplished: parameter ${paramName} not found`);
        }
        
        return isParam || isOptional ? paramValue : part;
      })
      .join('/');
    } catch (error) {console.error(error)}
}

export const formatedTime = (date) => {

  let dateInstance = new Date(date);
  let month = dateInstance.getMonth() + 1;
  return `${dateInstance.getHours().toString().length > 1 ? dateInstance.getHours() : `0${dateInstance.getHours()}`}:${dateInstance.getMinutes().toString().length > 1 ? dateInstance.getMinutes() : `0${dateInstance.getMinutes()}`}
          ${dateInstance.getDate()}/${month.toString().length > 1 ? month : `0${month}`}/${dateInstance.getFullYear()}`;
}

// export const formatedPrice = (currentPrice, currency, hint) => {
//   if(currency == 'BTC'){
//     let onlyNumbersFromBTC = new Intl.NumberFormat(hint, { style: 'currency', currency: currency, maximumFractionDigits: 8, minimumFractionDigits: 2 }).format(currentPrice).replace('BTC', '');
//     return onlyNumbersFromBTC + ' BTC';
//   }
//   return Number(currentPrice).toLocaleString(currency == 'USD' ? 'en-US' : hint || navigator.language, { style: 'currency', currency: currency, maximumFractionDigits: 8, minimumFractionDigits: 2 })
//   .replace('₴', 'грн');
// }

export const formatedPrice = (currentPrice, currency, hint = Auth.primary_user_language) => {
  try{
  if(currency == 'IMPL'){
    let onlyNumbersFromBTC = new Intl.NumberFormat(hint, { style: 'currency', currency: 'BTC', maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(currentPrice).replace('BTC', '');
    return onlyNumbersFromBTC + ' IMPL';
  }
  if(currency == 'BTC'){
      let onlyNumbersFromBTC = new Intl.NumberFormat(hint, { style: 'currency', currency: currency, maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(currentPrice).replace('BTC', '');
      return onlyNumbersFromBTC + ' BTC';
  }
  return new Intl.NumberFormat(currency == 'USD' ? 'en-US' : hint, { style: 'currency', currency: currency, maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(currentPrice).replace('₴', 'грн').replace('грн.', 'грн');
  }catch{
      return currentPrice + ' ' + currency

  }
}

export function abbreviateNumber(value) {;
    let newValue;
    switch (String(value).length) {
        case 6: {newValue = numeral(value).format('0a').replace('k', 'K').replace('m', 'M'); break;}
        default: {newValue = numeral(value).format('0.0a').replace('.0', '').replace('k', 'K').replace('m', 'M');}
    }
    return newValue;
}

export const roundeWithDec = (value) => {

  let sign = '';
  if(value < 0){
    value = Math.abs(value);
    sign = '-';
  }
  const whole = Math.floor(Number(value));
  const decimal = Math.abs(Math.round((Number(value) % 1) * 100));
  const marker = (1.1).toLocaleString().charAt(1);

  if (decimal < 10) {
    return `${sign}${whole.toLocaleString()}${marker}0${decimal.toString()}`;
  }
  return `${sign}${whole.toLocaleString()}${marker}${decimal.toString()}`;
}


const Clipboard = (function(window, document, navigator) {
  var textArea,
      copy;

  function isOS() {
      return navigator.userAgent.match(/ipad|iphone/i);
  }


  function createTextArea(text) {
      textArea = document.createElement('textArea');
      textArea.value = text;
      document.body.appendChild(textArea);
  }

  function selectText() {
      var range,
          selection;

      if (isOS()) {
          range = document.createRange();
          range.selectNodeContents(textArea);
          selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textArea.setSelectionRange(0, 999999);
      } else {
          textArea.select();
      }
  }

  function copyToClipboard() {
      document.execCommand('copy');
      document.body.removeChild(textArea);
  }

  copy = function(text) {

      createTextArea(text);
      selectText();
      copyToClipboard();
      
  };

  return {
      copy: copy
  };
})(window, document, navigator);

export const copyToClipboard = Clipboard.copy; 


export const RoutePassProps = ({ component: Component, redirect, ...rest }) =>
(!redirect
  ? <Route {...rest} render={props => <Component {...props} {...rest} />} />
  : <Redirect to={`${redirect}`} />);


export const sleep = (t) => {
  return new Promise(res => {
    setTimeout(res, t)
  })
} 

export const fixEmpty = (v) => {
  return !!v && v.toString().length>0 && v.toString() != 'undefined' ? v : '-'
} 
export const isMobile = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
export const collect = (Auth) => {
  try {if(!(window.localStorage)) return {}} catch (error) {return {}}
  
  let trackID = window.localStorage.getItem('trackID')
  let sessionID = window.sessionStorage.getItem('sessionID')


  if(!trackID){
    trackID = getUniqueKey(getUniqueKey());
    window.localStorage.setItem('trackID', trackID)
  }

  if(!sessionID){
    sessionID = getUniqueKey(getUniqueKey());
    window.sessionStorage.setItem('sessionID', sessionID)
  }

    // Opera 8.0+
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';

  // Safari 3.0+ "[object HTMLElementConstructor]" 
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1 - 71
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  // Edge (based on chromium) detection
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

  // Blink engine detection
  var isBlink = (isChrome || isOpera) && !!window.CSS;



  let browser;

  switch(true){
    case isOpera: {
      browser = 'Opera'
    }
    case isFirefox: {
      browser = 'Firefox'
    }
    case isSafari: {
      browser = 'Safari'
    }
    case isIE: {
      browser = 'IE'
    }
    case isEdge: {
      browser = 'Edge'
    }
    case isChrome: {
      browser = 'Chrome'
    }
  }

 
  
  return {
    trackID,
    sessionID,
    name: Auth.first_name,
    email: Auth.email,
    isAuthenticated: Auth.isAuthenticated,
    browser: browser,
    date: new Date,
    isMobile: isMobile()
  }

} 



export const ifLanguageDoesNotSupportUseEnExceptUK = (hint) => {

  const languages = {
    EN: 'en',
    RU: 'ru',
    UK: 'uk',
  }
  // if( 'uk' == hint ){
  //   return 'ru'; // except for Ukraine.
  // }
  
  if(hint)
  for( let l of Object.values(languages)){

    if(hint == l){
      return l;
    }
  }


  for( let l of navigator.languages){
    let lSpriped =  l.match(/[a-zA-Z]{2,10}/g)[0];
    // if( 'uk' == lSpriped.toLowerCase() ){
    //   return 'ru'; // except for Ukraine.
    // }
    if(Object.values(languages).includes( lSpriped )){
        return lSpriped;
    }
  }

  return 'en';
  
}

export const setup = (obj, [referrer, formFactor, productId, schemeColor] = [null, null, null, '#7186E5'] ) => {
  if(obj.props.location.state ){

    if(obj.props.location.state.from && obj.props.location.state.from.state){
      obj.referrer = obj.props.location.state.from.state.referrer;
      obj.formFactor = obj.props.location.state.from.state.formFactor;
      obj.productId = obj.productId || obj.props.location.state.from.state.productId;
      obj.schemeColor = obj.props.location.state.from.state.color || schemeColor;

    }else{
      obj.referrer = obj.props.location.state.referrer;
      obj.formFactor = obj.props.location.state.formFactor;
      obj.productId = obj.productId || obj.props.location.state.productId;
      obj.schemeColor = obj.props.location.state.color || schemeColor;

    }

  }else{
    obj.referrer = referrer;
    obj.formFactor = formFactor;
    obj.productId = productId;
  }

  return [obj.referrer, obj.formFactor, obj.productId, obj.schemeColor]

}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export const mergeDeep = (target, ...sources)  => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}


export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const uniqBy = (arr, predicate, isNullUnique = true, returnUnique = false ) => {

  if(!(arr && arr.length)) return [];
  
  function resolve(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
  }

  const cb = typeof predicate === 'function' ? predicate : (o) => resolve(predicate, o);
  
  return [...arr.reduce((map, item, idx) => {
    let key = cb(item);

    const r = (key) => {
      if(isNullUnique && key === null) key = idx; // every null is uniq
      map.has(key) || map.set(key, 
        returnUnique && typeof returnUnique == 'string'? {[returnUnique]:key} : item);
    }

    Array.isArray(key) && key.map(r) || r(key)
    
    return map;
  }, new Map()).values()];
};

export const checkUrl = (path, name) => {
  if(/^https?:\/\//.test(name)){
    return name.replace(/^https?:/, location.protocol)
  }

  if(!name){
    return location.origin + noimage
  }

  if(name && name.startsWith('/') && path.substr(-1).startsWith('/'))
    return path + name.substr(1);

  return path + name
}

export const parseHTML = (content) => {
  let div = document.createElement('div');
  div.innerHTML = content;
  return div.innerHTML;
}


export const converBolleanToString = (v) => {
  if ( typeof v === 'boolean' ){
    return v ? 'yes' : 'no'; 
  }
  return v
}

export const isTouchDevice = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

export async function Image2Blob(url){

  let text = await(await fetch(url)).text(); // should be readable stream
  if(text.includes('svg')){

    const parser = new DOMParser();
    const document = parser.parseFromString(text, 'image/svg+xml');

    const serializer = new XMLSerializer();
    const newSource = serializer.serializeToString(document);
    
    const loaded = new Promise((resolve, reject) => {
      resolve(new Blob([newSource], { type: 'image/svg+xml' }));  
    });
    return await loaded;
  }else{

    const img = new Image();
    var c = document.createElement("canvas");
    var ctx = c.getContext("2d");
    img.crossOrigin = 'anonymous';
  //  document.firstElementChild.appendChild(c)
    img.src = url;
    const loaded = new Promise((resolve, reject) => {
      img.onload = () => {
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        ctx.globalAlpha = 0;
        ctx.fillRect( 0, 0, c.width, c.height);
        ctx.globalAlpha = 1;
        // ctx.fillStyle = 'transparent';
        // ctx.fillRect(0,0,500,500); // something in the background
        ctx.drawImage(img, 0, 0);
        c.toBlob(resolve, "image/png", 1);
      }
      img.onerror = () => reject(Error('Image loading error'));
  
    });
    return await loaded;
  }
  // Always await loaded, as we may have bailed due to the Safari bug above.


}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export const Shortener = (props) => {
  let symbols = props.symbols || 20;
  let [expended, setExpended] = React.useState(false);
  const click = React.useCallback(e=>{
    e.preventDefault();
    e.stopPropagation();
    setExpended(!expended);
  },[expended]);

  if(!props.children) return <div/>
  if( props.children.length > symbols){
    if(!expended)
      return <span style={{width: props.width, display: 'inline-block', wordBreak: 'break-all'}}>{props.children.slice(0, symbols)} ...<button className='btn btn-mini btn-flat' onClick={click}>MORE</button></span>
    if(expended)
      return <span style={{width: props.width, display: 'inline-block', wordBreak: 'break-all'}}>{props.children} <button className='btn btn-mini btn-flat' onClick={click}>LESS</button></span>
  }
  return props.children

}


export const ShortenerWithTip = (props) => {
    const LightTooltip = withStyles(() => ({
        tooltip: {
            backgroundColor: '#4f6981',
            fontSize: 14,
        },
    }))(Tooltip);

    let symbols = props.symbols || 20;

    if(!props.children) return <div/>
    if(props.children.length > symbols){
      let phrase = '';
      if(props.cropMiddle){
        phrase = props.children.slice(0, symbols /2) + '...' + props.children.slice(-symbols /2);
      }else{
        phrase = props.children.slice(0, symbols) + '...';
      }

        return <LightTooltip placement="top" title={props.children}><span style={{maxWidth: props.width, display: 'inline-block', wordBreak: 'break-all', cursor: 'pointer'}}>{phrase}</span></LightTooltip>
    }
    return props.children

}

export const ShortenerWithoutTip = (props) => {
    let symbols = props.symbols || 20;

    if(!props.children) return <div/>
    if(props.children.length > symbols){
        let phrase = '';
        if(props.cropMiddle){
            phrase = props.children.slice(0, symbols /2) + '...' + props.children.slice(-symbols /2);
        }else{
            phrase = props.children.slice(0, symbols) + '...';
        }

        return <span style={{width: props.width, display: 'inline-block', wordBreak: 'break-all', fontSize: '12px'}}>{phrase}</span>
    }
    return props.children

}



export const isEqual = (value, other) => {

	// Get the value type
	var type = Object.prototype.toString.call(value);

	// If the two objects are not the same type, return false
	if (type !== Object.prototype.toString.call(other)) return false;

	// If items are not an object or array, return strict check
	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return value === other;

	// Compare the length of the length of the two items
	var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	// Compare two items
	var compare = function (item1, item2) {

		// Get the object type
		var itemType = Object.prototype.toString.call(item1);

		// If an object or array, compare recursively
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!isEqual(item1, item2)) return false;
		}

		// Otherwise, do a simple comparison
		else {

			// If the two items are not the same type, return false
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			// Else if it's a function, convert to a string and compare
			// Otherwise, just compare
			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	// Compare properties
	if (type === '[object Array]') {
		for (var i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (var key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}

	// If nothing failed, return true
	return true;

};

export const groupBy = (arr, criteria) => {
  if(!criteria) return arr
	return arr.reduce(function (obj, item) {

		// Check if the criteria is a function to run on the item or a property of it
		var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

		// If the key doesn't exist yet, create it
		if (!obj.hasOwnProperty(key)) {
			obj[key] = [];
		}

		// Push the value to the object
		obj[key].push(item);

		// Return the object to the next item in the loop
		return obj;

	}, {});
};


export const reinsert = (arr, from, to) => {
  const _arr = arr.slice(0);
  const val = _arr[from];
  _arr.splice(from, 1);
  _arr.splice(to, 0, val);
  return _arr;
}


function desc(a, b, orderBy) {
  if(isNaN(b[orderBy]) || isNaN(a[orderBy])) {
      if (b[orderBy] < a[orderBy]) {
          return -1;
      }
      if (b[orderBy] > a[orderBy]) {
          return 1;
      }
  }else{
      if (parseFloat(b[orderBy]) < parseFloat(a[orderBy])) {
          return -1;
      }
      if (parseFloat(b[orderBy]) > parseFloat(a[orderBy])) {
          return 1;
      }
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => -desc(a, b, orderBy) : (a, b) => desc(a, b, orderBy);
}

export const orderingBy = (arr, {sortedColumn = 'created_at', newColumn =  'order', groupColumn, getGroups}) => {

  let grouped = groupBy(arr, groupColumn);
  if(typeof getGroups == 'function') getGroups(grouped);

  return [].concat.apply([], Object.values(grouped).map(arr => {
    if(arr.every(row => row[newColumn])) return arr
    return stableSort(arr, getSorting('desc', sortedColumn)).map((row, idx) => {
      row[newColumn] = idx + 1;
      return row
    })  
  }))
}

export const statusTranslation = (status, orderStatus) => {

  switch (status) {
    case orderStatus.SHIPPED:
      return 'Paid';
      break;
    case orderStatus.PENDING:
      return 'Pending';
      break;
    case orderStatus.CANCELLED:
      return 'Canceled';
      break;
    case orderStatus.OVERDUE:
      return 'Overdue';
      break;
  
    default:
      break;
  }
}



export function list2tree(list) {
  var map = {}, node, roots = [], i;
  
  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i; // initialize the map
    list[i].children = []; // initialize the children
  }
  
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parent_id) {
      // if you have dangling branches check that map[node.parent_id] exists
      list[map[node.parent_id]].children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}

export function tree2list(tree){
  let cTree = Array.isArray( tree ) ? tree : [ tree ];
  if(!cTree.length) return cTree
  let nodes = cTree.map(node => {
    let item = {...node};
    let children = item.children;
    delete item.children
    return children ? [item].concat([],...tree2list(children)) : [item]
  })
  return [].concat([], ...nodes);
}

/**searchs through all arrays of the tree if the for a value from a property
 * @param tree : the tree array
 * @param compare : This function will receive each node. It's upon you to define which 
                     condition is necessary for the match. It must return true if the condition is matched. Example:
                        function(oNode){ if(oNode["Name"] === "AA") return true; }
 * @param allNodes? : us true to do not stop after the first match, default is false
 * @return an array with references to the nodes for which compare was true; In case no node was found an empty array
 *         will be returned
*/
export const _searchTree = function(tree, compare, {
  allNodes = false, 
  reverse = false, 
  flatten = false
  } = {
    allNodes: false, 
    reverse: false, 
    flatten: false
  }
  ){
  var stack = tree.slice(); // will contain the inner children
  var node; // always the current node
  var returnNodes = []; // the nodes array which will returned

  while(stack.length) {
    node = stack[reverse ? 'pop' : 'shift']()
      // check current node
      if( compare(node) ){
        if(allNodes){
          returnNodes.push(node)
        }else{
            return !flatten ? node : tree2list(node);
        }
             
      } else { 
        node.children && stack.push(...node.children)
      }
  }

  return !flatten ? returnNodes : tree2list(returnNodes);
}


export function getParentTree(tree, id) {
  var node;

  tree.some(function (n) {
      if (n.id === id) {
          return node = n;
      }
      if (n.children) {
          return node = getParentTree(n.children, id);
      }
  });
  return node || null;
}

export function traverseTree(tree, fun) {
  let cTree = Array.isArray( tree ) ? tree : [ tree ];
  if(!cTree.length) return []
  //visit children of current
  cTree.forEach(fun);
  cTree.forEach(({children}) => {
    traverseTree(children, fun);
  });

}

export function shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}


export function LinearProgressWithLabel(props) {
    const StyledLinearProgress = withStyles((theme) => ({
        bar: {
            backgroundColor: props.color,
            borderRadius: '10px'
        },
        colorPrimary: {
            backgroundColor: "transparent",
        },
        root: {
            borderRadius: '10px'
        }
    }))(LinearProgress);
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <StyledLinearProgress variant="determinate" value={(props.value && props.label) ? props.value : 0} />
            </Box>
            <Box minWidth={35}>
                <span style={{fontSize: '14px'}}>{props.label ? props.label : 0}</span>
            </Box>
        </Box>
    );
}

// Hook
export function useWhyDidYouUpdate(name, props) {
  // Get a mutable ref object where we can store props ...
  // ... for comparison next time this hook runs.
  const previousProps = React.useRef();

  React.useEffect(() => {
    if (previousProps.current) {
      // Get all keys from previous and current props
      const allKeys = Object.keys({ ...previousProps.current, ...props });
      // Use this object to keep track of changed props
      const changesObj = {};
      // Iterate through keys
      allKeys.forEach(key => {
        // If previous is different from current
        if (previousProps.current[key] !== props[key]) {
          // Add to changesObj
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key]
          };
        }
      });

      // If changesObj not empty then output to console
      if (Object.keys(changesObj).length) {
        console.log('[why-did-you-update]', name, changesObj);
      }
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
  });
}




//hooks

export function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}

let util = {};
util.debounce = debounce;
util.call = call;
util.listener = listener;
util.delegate = delegate;
util.hasClass = hasClass;
util.addClass = addClass;
util.removeClass = removeClass;
util.getUniqueKey = getUniqueKey;
util.getParameterByName = getParameterByName;
util.requestAnimationFramePromise = requestAnimationFramePromise  ;
export default util;

